import React, { useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router";
import LocalBreadcrumbs from "../../components/Breadcrumbs/LocalBreadcrumbs";
import Api from "../../services/Api";
import {renderOnTrack} from "../DevelopmentPlan/helpers";
import {VisionStatementInterface} from "../DevelopmentPlan/interfaces";
import CustomButton from "../../components/CustomButton";
import {useTranslation} from "react-i18next";
import {getLanguage} from "../../lang/helpers";
import iconCamera from "url:shared-assets/icons/video/camera-on.svg";
import iconChat from "url:shared-assets/icons/chat.svg";


interface TeamMember {
  clientId: string;
  name: string;
  visionStatements: number;
  visionStatementsShared: Array<VisionStatementInterface>;
  tasks: number;
}



const TeamMember: React.FC = () => {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(); // i18n translation hook
  const lang = getLanguage(i18n.language);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [teamName, setTeamName] = useState<string>("");
  const [member, setMember] = useState<TeamMember | null>(null);
  const { clientId } = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    api
      .get("client/team/member/" + clientId)
      .then((response) => {
        if (response.json.error) {
          setError(response.json.error);
        } else {
          setTeamName(response.json.teamName);
          setMember(response.json.member);
          setLoaded(true);
        }
      })
      .catch((error) => {
        alert("Unknown error (http status " + error.response.status + ")");
      });
  };

  if (error.length > 0) {
    return <div className="mt-4">Error: {error}</div>;
  }

  if (!loaded) {
    return <div className="mt-4">Loading...</div>;
  }

  if (!member) {
    return <div className="mt-4">No member!?</div>;
  }

  return (
    <>
      <LocalBreadcrumbs crumbs={[
        {name: "Team", url: "/team"},
        {name: member.name},
      ]}/>

      <div className="mt-4 z-heading1">
        {member.name}
      </div>

      <div className="flex flex-wrap gap-4 mt-6">
        <div className="">
          <p className="font-medium text-gray-400">
            Goals
          </p>
          <div className="main-half-col bg-indigo-900 p-4 mt-2 rounded-md">

            <div>{member.visionStatements} Goals in total</div>

            {
              member.visionStatementsShared.map((vs, i) => (
                <div key={"vs_" + i} className="my-2 cursor-pointer"
                     onClick={() => navigate('/team/vision_statement/' + vs.id)}>
                  <div className="flex items-center justify-between">
                    <p className="z-title1">{vs.title}</p>
                    {renderOnTrack(vs.onTrack, lang)}
                  </div>
                  <p className="z-body2">Due date: {vs.deadline}</p>
                  <p className="z-body2">Progress: {vs.progress}%</p>
                </div>
              ))
            }

          </div>

        </div>

        <div className="main-half-col">
          <p className="font-medium text-gray-400">
            Tools
          </p>
          <div className="bg-indigo-900 p-4 mt-2 rounded-md">
            <div className="flex items-center gap-x-4">
              <img src={iconCamera} alt="camera" className="h-6 w-6"/>
              <div className="z-title2">Video meeting</div>
            </div>

            <div className="flex items-center gap-x-4 mt-4">
              <img src={iconChat} alt="chat" className="h-6 w-6"/>
              <div className="z-title2">Chat</div>
            </div>

            <CustomButton buttonType="outlineWhiteBase" className="mt-4"
                          onClick={() => alert("Almost done :-/")}>
              Add Goal
            </CustomButton>

          </div>
        </div>
      </div>
    </>
  );
};

export default TeamMember;
